module.exports = __webpack_public_path__ + "static/scale-model-of-san-antonio-river-walk-in-san-antonio-texas-89102a11e70d76dc701c8217011762ed.png";